import React, { useMemo, useState, useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';
import OperationsHeader from './OperationsHeader';
import OrdersWithIssuesSection from './OrdersWithIssuesSection';
import SectionWithDownload from './SectionWithDownload';
import EmptyStateBox from './EmptyStateBox';
import GlossaryModal from './GlossaryModal';
import { Container, SectionTitle } from './styles';

const Operations: React.FC = () => {
  const { isDarkMode } = useTheme();
  const [glossaryOpen, setGlossaryOpen] = useState(false);

  const theme = useMemo(
    () => ({ mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' }),
    [isDarkMode]
  );
  const antdConfig = useMemo(() => getAntdThemeConfig(isDarkMode), [isDarkMode]);

  const handleGlossaryOpen = useCallback(() => setGlossaryOpen(true), []);
  const handleGlossaryClose = useCallback(() => setGlossaryOpen(false), []);
  const handleDownload = useCallback(() => {}, []);

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider theme={antdConfig}>
        <Container>
          <OperationsHeader onGlossaryClick={handleGlossaryOpen} />

          <SectionTitle level={5}>Orders with issues</SectionTitle>
          <OrdersWithIssuesSection />

          <SectionWithDownload title="Top inaccurate orders" onDownload={handleDownload}>
            <EmptyStateBox message="No orders found" />
          </SectionWithDownload>

          <SectionWithDownload title="Order issues by hour" onDownload={handleDownload}>
            <EmptyStateBox message="No orders found" />
          </SectionWithDownload>

          <SectionWithDownload title="Online rate" onDownload={handleDownload}>
            <EmptyStateBox message="No data yet" />
          </SectionWithDownload>

          <GlossaryModal open={glossaryOpen} onClose={handleGlossaryClose} />
        </Container>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default Operations;
